var path = 'src/app/patients/renal-progression/renal-progression.html';
var html = "<h1 class=page-header>Renal Disease Progression</h1> <div renal-progression-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/renal-progression/renal-progression.html
 ** module id = 563
 ** module chunks = 0
 **/